import { activeElementScrollIntoView, onKeyBoardPopup } from '@/utils/helper'

export default {
  install(Vue) {
    window.addEventListener('resize', e => {
      onKeyBoardPopup()
    })
  },
}
